import { Component } from '@angular/core';

import { ModalComponent } from '../modal/modal.component';
import { Inspection } from '../shared/models';
import { BaseMenuComponent } from './base.menu';

@Component({
    templateUrl: './children-inspection-list.menu.html',
    standalone: false
})
export class ChildrenInspectionListMenuComponent extends BaseMenuComponent {
  inspection: Inspection;

  constructor(public modal: ModalComponent) {
    super(modal);
  }

  init(data: any) {
    this.inspection = data.inspection;
    this.selectedGroup = data.group || 'general';
  }
}
